/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BaseSubscribeConfigObject } from './BaseSubscribeConfigObject';
import {
    BaseSubscribeConfigObjectFromJSON,
    BaseSubscribeConfigObjectFromJSONTyped,
    BaseSubscribeConfigObjectToJSON,
} from './BaseSubscribeConfigObject';
import type { SubscribeInstallationProviderOptions } from './SubscribeInstallationProviderOptions';
import {
    SubscribeInstallationProviderOptionsFromJSON,
    SubscribeInstallationProviderOptionsFromJSONTyped,
    SubscribeInstallationProviderOptionsToJSON,
} from './SubscribeInstallationProviderOptions';

/**
 * 
 * @export
 * @interface BaseSubscribeConfig
 */
export interface BaseSubscribeConfig {
    /**
     * 
     * @type {{ [key: string]: BaseSubscribeConfigObject; }}
     * @memberof BaseSubscribeConfig
     */
    objects?: { [key: string]: BaseSubscribeConfigObject; };
    /**
     * 
     * @type {SubscribeInstallationProviderOptions}
     * @memberof BaseSubscribeConfig
     */
    providerOptions?: SubscribeInstallationProviderOptions;
}

/**
 * Check if a given object implements the BaseSubscribeConfig interface.
 */
export function instanceOfBaseSubscribeConfig(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BaseSubscribeConfigFromJSON(json: any): BaseSubscribeConfig {
    return BaseSubscribeConfigFromJSONTyped(json, false);
}

export function BaseSubscribeConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseSubscribeConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objects': !exists(json, 'objects') ? undefined : (mapValues(json['objects'], BaseSubscribeConfigObjectFromJSON)),
        'providerOptions': !exists(json, 'providerOptions') ? undefined : SubscribeInstallationProviderOptionsFromJSON(json['providerOptions']),
    };
}

export function BaseSubscribeConfigToJSON(value?: BaseSubscribeConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'objects': value.objects === undefined ? undefined : (mapValues(value.objects, BaseSubscribeConfigObjectToJSON)),
        'providerOptions': SubscribeInstallationProviderOptionsToJSON(value.providerOptions),
    };
}

